export default __webpack_public_path__ + "static/media/album3.09daf538.png";